var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
import React, { useCallback, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, IconButton, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SettingsIcon from '@mui/icons-material/Settings';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';
import HowToRegOutlinedIcon from '@mui/icons-material/HowToRegOutlined';
import { NavigationConfig } from '../../utils/navigation_config';
import GlobalSearch from '../uiComponents/globalSearch/GlobalSearch';
import HeaderWrapper from './HeaderStyles';
import { api_service } from '../../api/api_service';
import { api_urls } from '../../api/api_urls';
import { PortalSetupIcon } from '../icons';
import { baseColors } from '../../Themes/colors';
var routeTitleMap = (_a = {},
    _a[NavigationConfig.Dashboard] = 'Dashboard',
    _a[NavigationConfig.BacklogManagement] = 'Application Management',
    _a[NavigationConfig.ApplicationManagement] = 'Application Management',
    _a[NavigationConfig.CreateApplication] = 'Create New Application',
    _a[NavigationConfig.UserManagement] = 'User Management',
    _a[NavigationConfig.AdminManagement] = 'Admin Management',
    _a[NavigationConfig.RolesPermissions] = 'Admin Management',
    _a[NavigationConfig.MarketingConent] = 'Marketing Content',
    _a[NavigationConfig.ProgramManagement] = 'Portal Setup',
    _a[NavigationConfig.DealerManagement] = 'Portal Setup',
    _a[NavigationConfig.DealerProgramAssocation] = 'Portal Setup',
    _a[NavigationConfig.InsuranceConfig] = 'Global Settings',
    _a[NavigationConfig.ChatbotConfig] = 'Global Settings',
    _a[NavigationConfig.PaymentManagement] = 'Payment Management',
    _a[NavigationConfig.DocumentManagement] = 'Document Management',
    _a[NavigationConfig.BrandCustomization] = 'Brand Customization',
    _a[NavigationConfig.CustomerPortalChatbotFaqs] = 'Chatbot FAQs',
    _a[NavigationConfig.CustomerPortalAuditLogs] = 'Audit Logs',
    _a[NavigationConfig.CustomerPortalDashboard] = 'Customer Portal Dashboard',
    _a[NavigationConfig.CustomerPortalUserManagement] = 'Customer Portal Users',
    _a[NavigationConfig.CustomerPortalSupportManagement] = 'Customer Portal Support',
    _a[NavigationConfig.CustomerPortalRegistrationManagement] = 'Admin Registration',
    _a[NavigationConfig.Support] = 'Support',
    _a[NavigationConfig.ResubmitApplication] = 'Resubmit Application',
    _a[NavigationConfig.FundingLogManagement] = 'Funding Queue',
    _a);
function getIconForRoute(pathname) {
    if (pathname.startsWith(NavigationConfig.Dashboard))
        return React.createElement("span", { className: "icon-Card" });
    if (pathname.startsWith(NavigationConfig.BacklogManagement))
        return React.createElement("span", { className: "icon-file" });
    if (pathname.startsWith(NavigationConfig.ApplicationManagement))
        return React.createElement("span", { className: "icon-file" });
    if (pathname.startsWith(NavigationConfig.UserManagement))
        return React.createElement("span", { className: "icon-Management" });
    if (pathname.startsWith(NavigationConfig.AdminManagement))
        return React.createElement("span", { className: "icon-shield-check" });
    if (pathname.startsWith(NavigationConfig.RolesPermissions))
        return React.createElement("span", { className: "icon-shield-check" });
    if (pathname.startsWith(NavigationConfig.MarketingConent))
        return React.createElement("span", { className: "icon-campaign" });
    if (pathname.startsWith(NavigationConfig.ProgramManagement))
        return React.createElement(PortalSetupIcon, null);
    if (pathname.startsWith(NavigationConfig.DealerManagement))
        return React.createElement(PortalSetupIcon, null);
    if (pathname.startsWith(NavigationConfig.DealerProgramAssocation))
        return React.createElement(PortalSetupIcon, null);
    if (pathname.startsWith(NavigationConfig.InsuranceConfig))
        return React.createElement(SettingsIcon, null);
    if (pathname.startsWith(NavigationConfig.ChatbotConfig))
        return React.createElement(SettingsIcon, null);
    if (pathname.startsWith(NavigationConfig.PaymentManagement))
        return React.createElement("span", { className: "icon-credit-card" });
    if (pathname.startsWith(NavigationConfig.DocumentManagement))
        return React.createElement("span", { className: "icon-landscape-document" });
    if (pathname.startsWith(NavigationConfig.BrandCustomization))
        return React.createElement("span", { className: "icon-color-palette" });
    if (pathname.startsWith(NavigationConfig.CustomerPortalChatbotFaqs))
        return React.createElement(ChatBubbleOutlineOutlinedIcon, { sx: { fontSize: 24 } });
    if (pathname.startsWith(NavigationConfig.CustomerPortalAuditLogs))
        return React.createElement(FactCheckOutlinedIcon, { sx: { fontSize: 24 } });
    if (pathname.startsWith(NavigationConfig.CustomerPortalDashboard))
        return React.createElement("span", { className: "icon-Card" });
    if (pathname.startsWith(NavigationConfig.CustomerPortalUserManagement))
        return React.createElement("span", { className: "icon-profile" });
    if (pathname.startsWith(NavigationConfig.CustomerPortalRegistrationManagement))
        return React.createElement(HowToRegOutlinedIcon, { sx: { fontSize: 24 } });
    if (pathname.startsWith(NavigationConfig.CustomerPortalSupportManagement))
        return React.createElement("span", { className: "icon-question" });
    if (pathname.startsWith(NavigationConfig.Support))
        return React.createElement("span", { className: "icon-help" });
    if (pathname.startsWith(NavigationConfig.ResubmitApplication))
        return React.createElement("span", { className: "icon-Reload" });
    return React.createElement("span", { className: "icon-file" });
}
function getPageTitle(pathname) {
    for (var _i = 0, _a = Object.keys(routeTitleMap); _i < _a.length; _i++) {
        var route = _a[_i];
        if (pathname.startsWith(route))
            return routeTitleMap[route];
    }
    return '';
}
var MODULE_OPTIONS = [
    { label: 'All Deals', value: 'global' },
    { label: 'Backlog', value: 'module' },
];
function getDetailCustomerName(detailInfo) {
    var _a, _b, _c, _d, _e, _f;
    var customers = (_a = detailInfo === null || detailInfo === void 0 ? void 0 : detailInfo.RelatedAccounts) === null || _a === void 0 ? void 0 : _a.CustomerInfo;
    if (!Array.isArray(customers) || customers.length === 0)
        return '';
    var primaryCustomer = (_b = customers.find(function (customer) { return (customer === null || customer === void 0 ? void 0 : customer.IsPrimary) === 1; })) !== null && _b !== void 0 ? _b : customers[0];
    var firstName = ((_c = primaryCustomer === null || primaryCustomer === void 0 ? void 0 : primaryCustomer.FirstName) !== null && _c !== void 0 ? _c : '').toString().trim();
    var middleName = ((_d = primaryCustomer === null || primaryCustomer === void 0 ? void 0 : primaryCustomer.MiddleName) !== null && _d !== void 0 ? _d : '').toString().trim();
    var lastName = ((_e = primaryCustomer === null || primaryCustomer === void 0 ? void 0 : primaryCustomer.LastName) !== null && _e !== void 0 ? _e : '').toString().trim();
    var fullName = [firstName, middleName, lastName].filter(Boolean).join(' ').trim();
    return fullName || ((_f = primaryCustomer === null || primaryCustomer === void 0 ? void 0 : primaryCustomer.BusinessName) !== null && _f !== void 0 ? _f : '').toString().trim();
}
var Header = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    var showSearchBar = _a.showSearchBar, label = _a.label, showBackButton = _a.showBackButton, onBack = _a.onBack, leftIcon = _a.leftIcon, detailInfo = _a.detailInfo, appDetailInfo = _a.appDetailInfo;
    var location = useLocation();
    var navigate = useNavigate();
    var title = getPageTitle(location.pathname);
    var isDetailHeader = Boolean(showBackButton);
    var _o = useState([]), searchResults = _o[0], setSearchResults = _o[1];
    var _p = useState(false), isSearching = _p[0], setIsSearching = _p[1];
    var _q = useState(false), isLoadingMore = _q[0], setIsLoadingMore = _q[1];
    var _r = useState(false), hasMore = _r[0], setHasMore = _r[1];
    var _s = useState(false), hasSearchError = _s[0], setHasSearchError = _s[1];
    var _t = useState(1), currentPage = _t[0], setCurrentPage = _t[1];
    var _u = useState(''), currentQuery = _u[0], setCurrentQuery = _u[1];
    var _v = useState('global'), currentModule = _v[0], setCurrentModule = _v[1];
    var pageSize = 15;
    var requestSeqRef = useRef(0);
    var mapContracts = function (contracts) {
        return contracts.map(function (c) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            var resolvedStatus = (_d = (_c = (_b = (_a = c === null || c === void 0 ? void 0 : c.Status) !== null && _a !== void 0 ? _a : c === null || c === void 0 ? void 0 : c.status) !== null && _b !== void 0 ? _b : c === null || c === void 0 ? void 0 : c.AspireStatus) !== null && _c !== void 0 ? _c : c === null || c === void 0 ? void 0 : c.ContractStatus) !== null && _d !== void 0 ? _d : null;
            return {
                id: (_g = (_f = (_e = c.ContractAspireId) !== null && _e !== void 0 ? _e : c.TxAspireOId) !== null && _f !== void 0 ? _f : c.ContractId) !== null && _g !== void 0 ? _g : '',
                name: (_h = c.CustomerName) !== null && _h !== void 0 ? _h : '',
                TxAspireOId: c.TxAspireOId,
                ContractAspireId: c.ContractAspireId,
                status: resolvedStatus,
                Status: resolvedStatus,
                AspireStatus: (_j = c === null || c === void 0 ? void 0 : c.AspireStatus) !== null && _j !== void 0 ? _j : resolvedStatus,
                ContractStatus: (_k = c === null || c === void 0 ? void 0 : c.ContractStatus) !== null && _k !== void 0 ? _k : resolvedStatus,
            };
        });
    };
    var dedupeItems = function (items) {
        var seen = new Set();
        return items.filter(function (item) {
            var _a, _b;
            var key = "".concat((_a = item.TxAspireOId) !== null && _a !== void 0 ? _a : '', "|").concat((_b = item.id) !== null && _b !== void 0 ? _b : '');
            if (seen.has(key))
                return false;
            seen.add(key);
            return true;
        });
    };
    var performSearch = useCallback(function (value, moduleValue, page, append) {
        if (page === void 0) { page = 1; }
        if (append === void 0) { append = false; }
        return __awaiter(void 0, void 0, void 0, function () {
            var trimmedValue, requestSeq, payload, dealCategory, res, label_1, fetchedItems_1, fetchedCount, hasMoreByCount, hasMoreByPageFill, _a;
            var _b, _c, _d, _e, _f, _g, _h, _j;
            return __generator(this, function (_k) {
                switch (_k.label) {
                    case 0:
                        trimmedValue = value.trim();
                        if (!trimmedValue || trimmedValue.length < 3) {
                            setSearchResults([]);
                            setHasMore(false);
                            setHasSearchError(false);
                            setCurrentPage(1);
                            setCurrentQuery('');
                            return [2];
                        }
                        if (append) {
                            setIsLoadingMore(true);
                        }
                        else {
                            setIsSearching(true);
                            setHasSearchError(false);
                            setCurrentPage(1);
                        }
                        setCurrentQuery(trimmedValue);
                        setCurrentModule(moduleValue);
                        requestSeq = ++requestSeqRef.current;
                        payload = {
                            SearchString: trimmedValue,
                            Page: page,
                            pageSize: pageSize,
                            Size: pageSize,
                        };
                        _k.label = 1;
                    case 1:
                        _k.trys.push([1, 3, 4, 5]);
                        dealCategory = moduleValue === 'global' ? 'ALL_DEALS' : 'BACKLOG_QUEUE';
                        return [4, api_service.post({
                                endPoint: api_urls.GET_TOTAL_CONTRACTS,
                                payLoad: __assign(__assign({}, payload), { DealCategory: dealCategory }),
                            })];
                    case 2:
                        res = _k.sent();
                        if (requestSeq !== requestSeqRef.current) {
                            return [2];
                        }
                        if (((_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.statusCode) !== 200) {
                            throw new Error(((_c = res === null || res === void 0 ? void 0 : res.data) === null || _c === void 0 ? void 0 : _c.message) || 'Search request failed.');
                        }
                        label_1 = dealCategory === 'ALL_DEALS' ? 'All Deals' : 'Backlog Queue';
                        fetchedItems_1 = mapContracts((_f = (_e = (_d = res === null || res === void 0 ? void 0 : res.data) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.Contracts) !== null && _f !== void 0 ? _f : []);
                        fetchedCount = Number((_j = (_h = (_g = res === null || res === void 0 ? void 0 : res.data) === null || _g === void 0 ? void 0 : _g.data) === null || _h === void 0 ? void 0 : _h.Count) !== null && _j !== void 0 ? _j : 0);
                        setSearchResults(function (prev) {
                            var _a, _b;
                            var prevItems = append ? ((_b = (_a = prev[0]) === null || _a === void 0 ? void 0 : _a.items) !== null && _b !== void 0 ? _b : []) : [];
                            var merged = dedupeItems(__spreadArray(__spreadArray([], prevItems, true), fetchedItems_1, true));
                            return [{ label: label_1, items: merged }];
                        });
                        setCurrentPage(page);
                        hasMoreByCount = fetchedCount > 0 ? page * pageSize < fetchedCount : false;
                        hasMoreByPageFill = fetchedItems_1.length === pageSize;
                        setHasMore(hasMoreByCount || hasMoreByPageFill);
                        return [3, 5];
                    case 3:
                        _a = _k.sent();
                        if (requestSeq !== requestSeqRef.current) {
                            return [2];
                        }
                        if (!append) {
                            setSearchResults([]);
                            setHasSearchError(true);
                        }
                        setHasMore(false);
                        return [3, 5];
                    case 4:
                        if (requestSeq === requestSeqRef.current) {
                            setIsSearching(false);
                            setIsLoadingMore(false);
                        }
                        return [7];
                    case 5: return [2];
                }
            });
        });
    }, []);
    var onGlobalSearch = useCallback(function (value) { performSearch(value !== null && value !== void 0 ? value : '', 'global', 1, false); }, [performSearch]);
    var onSearchComplete = useCallback(function (value) { performSearch(value !== null && value !== void 0 ? value : '', 'module', 1, false); }, [performSearch]);
    var handleLoadMore = useCallback(function () {
        if (isSearching || isLoadingMore || !hasMore || !currentQuery)
            return;
        performSearch(currentQuery, currentModule, currentPage + 1, true);
    }, [currentModule, currentPage, currentQuery, hasMore, isLoadingMore, isSearching, performSearch]);
    var handleResultClick = useCallback(function (item) {
        var _a, _b, _c, _d;
        if (!(item === null || item === void 0 ? void 0 : item.TxAspireOId))
            return;
        var status = (_d = (_c = (_b = (_a = item === null || item === void 0 ? void 0 : item.status) !== null && _a !== void 0 ? _a : item === null || item === void 0 ? void 0 : item.Status) !== null && _b !== void 0 ? _b : item === null || item === void 0 ? void 0 : item.AspireStatus) !== null && _c !== void 0 ? _c : item === null || item === void 0 ? void 0 : item.ContractStatus) !== null && _d !== void 0 ? _d : null;
        var url = "".concat(NavigationConfig.BacklogAppDetails, "/").concat(item.TxAspireOId);
        navigate(url, {
            state: {
                status: status,
            },
        });
    }, [navigate]);
    var customerName = getDetailCustomerName(detailInfo);
    var contractId = ((_b = detailInfo === null || detailInfo === void 0 ? void 0 : detailInfo.ContractData) === null || _b === void 0 ? void 0 : _b.ContractAspireId) || ((_c = detailInfo === null || detailInfo === void 0 ? void 0 : detailInfo.ContractData) === null || _c === void 0 ? void 0 : _c.ContractAspireRecordId) || '';
    var APPLICATION_TYPE_LABEL = {
        NOR: 'Credit',
        LOC: 'Line of Credit',
        TLC: 'Line of Credit',
        SCH: 'Takedown',
    };
    var transactionId = (_d = detailInfo === null || detailInfo === void 0 ? void 0 : detailInfo.ContractData) === null || _d === void 0 ? void 0 : _d.TxAspireOId;
    var applicationTypeCode = (_e = detailInfo === null || detailInfo === void 0 ? void 0 : detailInfo.ContractData) === null || _e === void 0 ? void 0 : _e.ContractCategory;
    var applicationType = applicationTypeCode
        ? (_f = APPLICATION_TYPE_LABEL[applicationTypeCode]) !== null && _f !== void 0 ? _f : applicationTypeCode
        : applicationTypeCode;
    var customerType = String((_h = (_g = detailInfo === null || detailInfo === void 0 ? void 0 : detailInfo.ContractData) === null || _g === void 0 ? void 0 : _g.FinanceProgramDescription) !== null && _h !== void 0 ? _h : '').toLowerCase().includes('consumer')
        ? 'Consumer'
        : 'Commercial';
    var contractStatus = (_k = (_j = appDetailInfo === null || appDetailInfo === void 0 ? void 0 : appDetailInfo.ContractStatusList) === null || _j === void 0 ? void 0 : _j.find(function (item) { var _a; return item.OId == ((_a = detailInfo === null || detailInfo === void 0 ? void 0 : detailInfo.ContractData) === null || _a === void 0 ? void 0 : _a.StatusOId); })) === null || _k === void 0 ? void 0 : _k.Status;
    var creditStatus = (_m = (_l = appDetailInfo === null || appDetailInfo === void 0 ? void 0 : appDetailInfo.CreditDecisions) === null || _l === void 0 ? void 0 : _l.find(function (item) { var _a; return item.CreditDecisionOId == ((_a = detailInfo === null || detailInfo === void 0 ? void 0 : detailInfo.ContractData) === null || _a === void 0 ? void 0 : _a.CreditDecisionOId); })) === null || _m === void 0 ? void 0 : _m.Decision;
    var headerInfoChips = [
        { label: 'Txn ID', value: transactionId !== null && transactionId !== void 0 ? transactionId : '' },
        { label: 'Customer Type', value: customerType },
        { label: 'App Type', value: applicationType !== null && applicationType !== void 0 ? applicationType : '' },
        { label: 'Status', value: contractStatus !== null && contractStatus !== void 0 ? contractStatus : '' },
        { label: 'Credit Status', value: creditStatus !== null && creditStatus !== void 0 ? creditStatus : '--' },
    ].filter(function (chip) { return chip.label === 'Credit Status' || (chip.value !== '' && chip.value !== undefined && chip.value !== null); });
    return (React.createElement(HeaderWrapper, null,
        React.createElement("div", { className: "header-left" },
            showBackButton ? (React.createElement(IconButton, { className: "back-btn", size: "small", onClick: onBack, sx: { color: 'inherit' } },
                React.createElement(ArrowBackIcon, { fontSize: "small" }))) : (React.createElement("div", { className: "header-icon" }, leftIcon !== null && leftIcon !== void 0 ? leftIcon : getIconForRoute(location.pathname))),
            isDetailHeader ? ((function () {
                var isBacklogDetails = location.pathname.startsWith(NavigationConfig.BacklogAppDetails);
                var chips = isBacklogDetails
                    ? headerInfoChips.filter(function (chip) { return chip.label === 'Txn ID' || chip.label === 'Customer Type' || chip.label === 'App Type'; })
                    : headerInfoChips;
                var title = (React.createElement(Typography, { className: "detail-title", variant: 'h6' },
                    customerName ? "".concat(customerName).concat(label ? ' | ' : '') : '',
                    contractId ? "AUX - ".concat(contractId) : ''));
                var chipNodes = chips.map(function (chip) { return (React.createElement(Box, { key: chip.label, sx: {
                        display: 'inline-flex',
                        alignItems: 'baseline',
                        gap: 0.4,
                        px: 1,
                        py: 0.4,
                        ml: 1,
                        backgroundColor: baseColors.greyPreset[55],
                        borderRadius: 1,
                        border: "1px solid ".concat(baseColors.greyPreset[40]),
                        flexShrink: 0,
                    } },
                    React.createElement(Typography, { sx: { fontSize: 11, fontWeight: 500, color: baseColors.greyPreset[10], whiteSpace: 'nowrap' } },
                        chip.label,
                        ":"),
                    React.createElement(Typography, { sx: { fontSize: 11, fontWeight: 700, color: baseColors.fullBlack, whiteSpace: 'nowrap' } }, chip.value))); });
                return (React.createElement(React.Fragment, null,
                    title,
                    chipNodes));
            })()) : (React.createElement(Typography, { variant: 'h6' }, label || title))),
        showSearchBar && (React.createElement("div", { className: "header-center" },
            React.createElement(GlobalSearch, { moduleOptions: MODULE_OPTIONS, globalModuleValue: "global", globalSearchText: '', onGlobalSearch: onGlobalSearch, searchText: '', onSearchComplete: onSearchComplete, searchResults: searchResults, isSearching: isSearching, isLoadingMore: isLoadingMore, hasMore: hasMore, hasError: hasSearchError, onLoadMore: handleLoadMore, onResultClick: handleResultClick, placeholder: "Search By Application ID, Name", debounceTimer: 500, minSearchLength: 3 })))));
};
export default Header;
